import WebWorker from './webworker-http';
import { notification } from 'antd';
import { IconType } from 'antd/lib/notification/index';
import { log_out } from '../components/top-navbar/top-navbar';

// ██╗███╗   ██╗████████╗███████╗██████╗ ███████╗ █████╗  ██████╗███████╗
// ██║████╗  ██║╚══██╔══╝██╔════╝██╔══██╗██╔════╝██╔══██╗██╔════╝██╔════╝
// ██║██╔██╗ ██║   ██║   █████╗  ██████╔╝█████╗  ███████║██║     █████╗
// ██║██║╚██╗██║   ██║   ██╔══╝  ██╔══██╗██╔══╝  ██╔══██║██║     ██╔══╝
// ██║██║ ╚████║   ██║   ███████╗██║  ██║██║     ██║  ██║╚██████╗███████╗
// ╚═╝╚═╝  ╚═══╝   ╚═╝   ╚══════╝╚═╝  ╚═╝╚═╝     ╚═╝  ╚═╝ ╚═════╝╚══════╝
//                型          態          宣          告

export interface response_type {
  error?: string;
  message?: string;
  path?: string;
  status?: number;
  timestamp?: string;
  kind?: string;
  code?: number;
  index: number;
  reason?: string;
  config?: string;
  content?: object;
  items?: any[];
}

export interface http_props_type {
  log_out?: log_out_type;
  redirect_url?: string;
}

interface worker_type {
  postMessage: Function;
  addEventListener: Function;
  removeEventListener: Function;
  terminate: Function;
}

export interface datacenter_url {
  [key: string]: { internalUrl?: string; externalUrl?: string };
}

export interface arguments_type {
  /** 識別用的標籤，可自訂名稱，供 API 回傳值處理時識別用 */
  key: string;
  /** 把需要用到的組件 props 傳入 */
  props?: { log_out?: log_out_type; history?: any; redirect_url?: string; intl?: any; logout_body?: BodyInit | null | undefined };
  /** API 回傳值需要更新在哪個列表，該列表 context 的 set 函數 */
  func?: React.Dispatch<React.SetStateAction<any | undefined>> | React.Dispatch<React.SetStateAction<string | undefined>> | undefined;
  /** 呼叫的路徑，若為陣列即批次呼叫 */
  url: string | string[];
  /** HTTP 呼叫方法 (0 = GET, 1 = POST, 2 = PUT, 3 = DELETE, 4 = PATCH)
   * （若為 GET 即為該 API 的回傳值，若為 POST, PUT, DELETE, PATCH 則在處理完後會自動獲取該列表最新資料） */
  method: number;
  /** Request body，通常是 POST, PUT, PATCH 才需要 */
  body?: object;
  /** 為一個function，請求完後若要再處理資料，可以在此處理 */
  post_process?: Function;
  /** 自訂重新獲取列表的API網址 */
  refresh_url?: string;
  /** 不重新獲取列表 */
  no_refresh?: 1;
  /** 資料為字串 */
  is_string?: 1;
  /** 設置讀取完成狀態 */
  set_loading_done?: React.Dispatch<React.SetStateAction<{ [key: string]: 0 | 1 }>>;
  /** 為一個 function，自訂成功或錯誤的提示及其他動作 */
  custom_warning?: (response: response_type) => void;
  /** 不要彈出訊息 */
  no_message?: 1;
  /** 不要彈出成功訊息，失敗訊息會彈出 */
  no_success_message?: 1;
  /** 各 API 的權限，為一陣列
   * 範例：
   * [
   *    ...
   *    [0, '​/products​/info​/overview'],  // GET /products​/info​/overview
   *    [3, /\/products​\/name\/(.*)/],   // DELETE /products​/name/{productName}
   *    ...
   * ]
   */
  permissions?: [0 | 1 | 2 | 3 | 4, string | RegExp][];
  /** 送出的請求 Header 內容型態 */
  content_type?: string;
  /** 不要排序 response */
  no_sorting?: 1;
  /** 不要将response的驼峰改为谷歌_命名，默认会转 */
  no_underlined_key?: 1;
}

type log_out_type = typeof log_out;

const workers: { key: string; worker: WebWorker; listener: Function }[] = [];

/**
 * 顯示彈出式訊息
 * @param {IconType} type 訊息類型（成功/資訊/錯誤/警告）
 * @param {string} [title] 訊息標題
 * @param {string} [msg] 訊息內容
 */
export const openNotification = (type: IconType, title?: string, msg?: string): void => {
  notification[type]({
    message: title ? title : '',
    description: msg ? msg : ''
  });
};

/**
 * HTTP 請求
 * @param {string} key 識別用的標籤，可自訂名稱，供 API 回傳值處理時識別用
 * @param {{ log_out?: log_out_type; history?: any; redirect_url?: string; intl?: any; logout_body?: BodyInit | null | undefined }} props 把需要用到的組件 props 傳入
 * @param {(React.Dispatch<React.SetStateAction<any | undefined>> | React.Dispatch<React.SetStateAction<string | undefined>> | undefined)} func API 回傳值需要更新在哪個列表，該列表 context 的 set 函數
 * @param {(string | string[])} url 呼叫的路徑，若為陣列即批次呼叫
 * @param {number} method HTTP 呼叫方法 （0 = GET, 1 = POST, 2 = PUT, 3 = DELETE, 4 = PATCH）
 * （若為 GET 即為該 API 的回傳值，若為 POST, PUT, DELETE, PATCH 則在處理完後會自動獲取該列表最新資料）
 * @param {object} [body] Request body，通常是 POST, PUT, PATCH 才需要
 * @param {Function} [post_process] 為一個function，請求完後若要再處理資料，可以在此處理
 * @param {string} [refresh_url] 自訂重新獲取列表的API網址
 * @param {1} [no_refresh] 不重新獲取列表
 * @param {1} [is_string] 資料為字串
 * @param {(React.Dispatch<React.SetStateAction<{ [key: string]: 0 | 1 }>>)} [set_loading_done] 設置讀取完成狀態
 * @param {(response: response_type) => void} [custom_warning] 為一個 function，自訂成功或錯誤的提示及其他動作
 * @param {1} [no_message] 不要彈出訊息
 *
 * @return {*}  {Promise<unknown>}
 */
export function http_request(
  key: string,
  props: { log_out?: log_out_type; history?: any; redirect_url?: string; intl?: any },
  func: React.Dispatch<React.SetStateAction<any | undefined>> | React.Dispatch<React.SetStateAction<string | undefined>> | undefined,
  url: string | string[],
  method: number,
  body?: object,
  post_process?: Function,
  refresh_url?: string,
  no_refresh?: 1,
  is_string?: 1,
  set_loading_done?: React.Dispatch<React.SetStateAction<{ [key: string]: 0 | 1 }>>,
  custom_warning?: (response: response_type) => void,
  no_message?: 1
): Promise<unknown> {
  return http_request_new({
    key,
    props,
    func,
    url,
    method,
    body,
    post_process,
    refresh_url,
    no_refresh,
    is_string,
    set_loading_done,
    custom_warning,
    no_message
  });
}

/**
 * HTTP 請求（參數使用 object 形式）
 * @param {arguments_type} args
 * @property {string} key 識別用的標籤，可自訂名稱，供 API 回傳值處理時識別用
 * @property {{ log_out?: log_out_type; history?: any; redirect_url?: string; intl?: any }} [props] 把需要用到的組件 props 傳入
 * @property {(React.Dispatch<React.SetStateAction<any | undefined>> | React.Dispatch<React.SetStateAction<string | undefined>> | undefined)} func API 回傳值需要更新在哪個列表，該列表 context 的 set 函數
 * @property {(string | string[])} url 呼叫的路徑，若為陣列即批次呼叫
 * @property {number} method HTTP 呼叫方法 （0 = GET, 1 = POST, 2 = PUT, 3 = DELETE, 4 = PATCH）
 * （若為 GET 即為該 API 的回傳值，若為 POST, PUT, DELETE, PATCH 則在處理完後會自動獲取該列表最新資料）
 * @property {object} [body] Request body，通常是 POST, PUT, PATCH 才需要
 * @property {Function} [post_process] 為一個 function，請求完後若要再處理資料，可以在此處理
 * @property {string} [refresh_url] 自訂重新獲取列表的API網址
 * @property {1} [no_refresh] 不重新獲取列表
 * @property {1} [is_string] 資料為字串
 * @property {(React.Dispatch<React.SetStateAction<{ [key: string]: 0 | 1 }>>)} [set_loading_done] 設置讀取完成狀態
 * @property {(response: response_type) => void} [custom_warning] 為一個 function，自訂成功或錯誤的提示及其他動作
 * @property {1} [no_message] 不要彈出訊息
 * @property {1} [no_success_message] 不要彈出成功訊息，失敗訊息會彈出
 * @property {1} [no_sorting] 不要排序 response
 * @property {1} [no_underlined_key] 不要将response的驼峰改为谷歌_命名，默认会转
 * @return {*}  {Promise<unknown>}
 */
export function http_request_new(args: arguments_type): Promise<unknown> {
  const { key }: arguments_type = args;

  destroy_worker(key);
  return new Promise((resolve: (value?: unknown) => void, reject: (reason?: any) => void): void => {
    const { permissions } = args;
    const { url, method } = args;
    const is_permitted_to_request: boolean = (() => {
      return !permissions?.find((iter: [0 | 1 | 2 | 3 | 4, string | RegExp]) => {
        const iter_regex = iter[1];
        return (
          method === iter[0] && (Array.isArray(url) ? url.find((url_each: string) => new RegExp(iter_regex).test(url_each)) : new RegExp(iter_regex).test(url))
        );
      });
    })();

    const { props, func, custom_warning }: any = args;
    if (is_permitted_to_request) {
      // 初始化 Web Worker
      const http_worker: worker_type = new WebWorker(args.post_process);

      // 傳遞訊息給 Web Worker，告訴 Web Worker 開始執行
      http_worker.postMessage(
        JSON.stringify({
          key,
          url,
          method,
          body: JSON.stringify(args.body),
          origin: window.location.origin,
          refresh_url: args.refresh_url,
          no_refresh: args.no_refresh,
          is_string: args.is_string,
          content_type: args.content_type,
          no_sorting: args.no_sorting,
          no_underlined_key: args.no_underlined_key,
        })
      );
      const format = props?.intl?.formatMessage;
      let first_response: response_type | undefined;

      /**
       * 新建接收器，接收從web worker傳來的訊息事件
       * @param {MessageEvent} event
       */
      const listener: Function = (event: MessageEvent): void => {
        if (event.data === 'done') first_response?.code && first_response.code > 399 && method > 0 ? reject(first_response) : resolve(first_response);
        else if (event.data === 'end') {
          http_worker.removeEventListener('message', listener);
          resolve(first_response);
        } else {
          const response = ((): [response_type, boolean] => {
              const data = event.data;
              try {
                return typeof data === 'string' ? JSON.parse(event.data) : data;
              } catch {
                return data;
              }
            })(),
            response_new: response_type | response_type[] = Array.isArray(response) ? response[0] : (response as unknown as response_type);

          if (response_new !== undefined) {
            !custom_warning &&
              response_new?.code === 401 /*&& key !== 'subscriptions'*/ &&
              props?.log_out?.({ props: props, history: props.history, redirect_url: props.redirect_url, logout_body: props.logout_body });
            if ((!response_new?.code || (response_new && response_new?.code < 400)) && func && (method === 0 || first_response)) {
              (func as React.Dispatch<React.SetStateAction<any>>)(response_new?.items || response_new);
              args.set_loading_done?.((current_state: { [key: string]: 0 | 1 }) => ({
                ...current_state,
                [key]: 1
              }));
            }
            if (response_new?.code && response_new?.code !== 200 && func && method === 0) {
              (func as React.Dispatch<React.SetStateAction<any>>)(undefined);
            }
            if (!first_response) {
              (!response_new?.code || response_new?.code < 400) && !response[1] && (first_response = response_new);
              if (custom_warning) custom_warning?.(response_new);
              else if (method > 0 && !args.no_message) {
                const actions: string[] = ['created', 'updated', 'deleted', 'updated' /*, action_name || ""*/];
                const space = ['zh-TW', 'zh-CN'].includes(props?.intl?.locale) ? '' : ' ';
                // index_of_service: number = path_to_service.findIndex((p) => p === path);
                if (response_new) {
                  if (response_new.code && response_new.code >= 400) {
                    openNotification('error', response_new.reason && response_new.reason, response_new.message);
                  } else if (key !== 'auth' && !args.no_success_message) {
                    openNotification(
                      'success',
                      format({ id: 'successful' }),
                      `${format({ id: key.substr(0, key.length) })}${space}${format({ id: actions[method - 1] })}${space}${format({
                        id: 'successfully'
                      })}`
                    );
                  }
                } else {
                  openNotification(
                    'error',
                    format({ id: 'error' }),
                    `${format({ id: key.substr(0, key.length - 1) })}${space}${format({ id: actions[method - 1] })}${space}${format({
                      id: 'error'
                    })}`
                  );
                }

                // response.code && response.code >= 400 ? message.error(response.reason && response.reason.response.status.message) : message.success(`${actions[method - 1]} Succesfully`);
              }

              first_response = response_new;
            }
          }
        }
      };
      http_worker.addEventListener('message', listener);

      // 將 web worker 和 listener 存下來，切換頁面時全部銷毀
      workers.push({ key, worker: http_worker, listener });
    } else resolve();
  });
}

/**
 * 銷毀 Web Worker
 *
 * 頁面切換或變動時，需要銷毀所有或特定類別的 Web Worker，以免滯留記憶體造成 Memory Leak 問題
 * @param {string} [key_selected]
 */
export function destroy_worker(key_selected?: string) {
  for (let i = 0; i < workers.length; i++) {
    const { key, worker, listener } = workers[i];
    if (!key_selected || (key_selected && key === key_selected)) {
      worker.removeEventListener('message', listener);
      worker.terminate();
    }
  }
}
